var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ShippingHeaderAdd',{attrs:{"title":_vm.$t('sequenciar-transportadora')},on:{"back":_vm.back}}),_c('ShippingSequenceTable')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }